/**
 * <EmailUpsellDialog> — what an Ember user sees when they click "Email…".
 * Pitches the Steel+ feature with a deep-link to /pricing.
 */
import React from 'react';
import { Mail } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { STEEL_PILL_GRADIENT } from './constants';

const UPSELL_BULLETS = [
  'Send PDF, Excel or CSV exports in one click',
  'Branded with Forge Ledger header, your name, and an exported timestamp',
  'Add a personal note for the recipient',
];

const EmailUpsellDialog = ({ open, onOpenChange, testIdPrefix }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white" data-testid={`${testIdPrefix}-email-upsell`}>
      <DialogHeader>
        <div
          className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-white text-[10px] font-bold uppercase tracking-wider w-fit mb-2"
          style={{ backgroundImage: STEEL_PILL_GRADIENT }}
        >
          <Mail className="w-3 h-3" />
          Steel feature
        </div>
        <DialogTitle className="text-2xl font-bold text-[#020617]">
          Email this report straight to anyone
        </DialogTitle>
        <DialogDescription className="text-[#64748B] pt-1">
          Steel users (and above) can email any export as a branded PDF — your accountant, a partner,
          your future self — without leaving the page. Available on Forge Ledger Steel.
        </DialogDescription>
      </DialogHeader>
      <ul className="mt-2 space-y-2 text-sm text-[#334155]">
        {UPSELL_BULLETS.map((bullet) => (
          <li key={bullet} className="flex items-start gap-2">
            <span className="mt-1 w-1.5 h-1.5 rounded-full bg-[#0052FF] inline-block flex-shrink-0" />
            <span>{bullet}</span>
          </li>
        ))}
      </ul>
      <div className="flex gap-3 pt-4">
        <Button
          type="button"
          onClick={() => { onOpenChange(false); window.location.href = '/pricing'; }}
          className="flex-1 text-white hover:opacity-90 border-0"
          style={{ backgroundImage: STEEL_PILL_GRADIENT, backgroundColor: 'transparent' }}
          data-testid={`${testIdPrefix}-email-upsell-cta`}
        >
          See Steel &amp; Damascus plans
        </Button>
        <Button
          type="button"
          onClick={() => onOpenChange(false)}
          className="flex-1 bg-[#F1F5F9] text-[#020617] hover:bg-[#E2E8F0]"
        >
          Maybe later
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default EmailUpsellDialog;
